import {Caption, TextCapitalization} from '@contentlab/types/captions';

const applyCapitalization = (
  text: string,
  capitalization: TextCapitalization
): string => {
  switch (capitalization) {
    case TextCapitalization.UPPERCASE:
      return text.toUpperCase();
    case TextCapitalization.LOWERCASE:
      return text.toLowerCase();
    default:
      return text;
  }
};

const applyCapitalizationToCaption = (
  caption: Caption,
  capitalization: TextCapitalization
): Caption => ({
  ...caption,
  text: applyCapitalization(caption.text, capitalization),
  wordTimings: caption.wordTimings?.map((word) => ({
    ...word,
    text: applyCapitalization(word.text, capitalization),
  })),
});

export default applyCapitalizationToCaption;
